import { render, staticRenderFns } from "./jhi-footer.vue?vue&type=template&id=0076a85c&"
import script from "./jhi-footer.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-footer.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/opt/jenkins/workspace/ice-registry_qatar-2.0.4-rebrand/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0076a85c')) {
      api.createRecord('0076a85c', component.options)
    } else {
      api.reload('0076a85c', component.options)
    }
    module.hot.accept("./jhi-footer.vue?vue&type=template&id=0076a85c&", function () {
      api.rerender('0076a85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/jhi-footer/jhi-footer.vue"
export default component.exports